// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticlesItemDetails-module__img--Lb45O,.ArticlesItemDetails-module__noImg--KTuE5{width:115px}.ArticlesItemDetails-module__noImg--KTuE5{height:115px;background-color:#7b7f83}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"img": `ArticlesItemDetails-module__img--Lb45O`,
	"noImg": `ArticlesItemDetails-module__noImg--KTuE5`
};
export default ___CSS_LOADER_EXPORT___;
